import paths from '~/lib/paths';

import { Redirect } from './Redirect';

export function LegacyICPRedirect() {
  return <Redirect to={paths.idealCustomerProfile()} />;
}
